import { Component, OnInit, ViewChild, Input, OnChanges, TemplateRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { Globle } from 'src/assets/globle';
import { OptionService } from '../../option.service';
import { Users } from '../users.model';
import { UsersService } from '../users.service';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-userslist',
  templateUrl: './userslist.component.html',
  styleUrls: ['./userslist.component.css'],
  queries: {
    contentRef1: new ViewChild("editModal"),
    contentRef2: new ViewChild("ModalConfirmApprove")
  },
})
export class UserslistComponent implements OnInit, OnChanges {

  users: Users[] = [];
  displayedColumns: string[] = ['name', "userName", 'email', 'phone', 'status', "role", "action"];
  dataSource!: MatTableDataSource<Users>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @Input() addNew: boolean = false;
  pageSize = 100;
  spinnerOverlay = false

  editName!: string;
  editEmail!: string;
  editPhone!: string;
  userId!: string;

  userLoginId: string = "";

  otpCounter: any;
  counterEnd: boolean = false;
  otpConfirm = "";

  public contentRef1!: TemplateRef<any>;
  public contentRef2!: TemplateRef<any>;
  constructor(private service: UsersService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    private optionService: OptionService,
    private dialog: MatDialog,
    private localStorage: LocalStorageService,
    private globle: Globle) { }

  ngOnInit(): void {
    this.pageSize = this.globle.pageSize;
    this.userLoginId = this.localStorage.retrieve("userInfo").userId
    this.getData();
  }

  ngOnChanges(changes: any): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (changes.addNew.currentValue) {
      this.getData();
    }
  }
  getData() {
    this.service.getWebUsers().subscribe(data => {
      this.users = data;
      this.dataSource = new MatTableDataSource(this.users);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error);
      })
  }

  confirmActivatUser() {
    var obj = {
      userLoginId: this.userLoginId,
      userId: this.userId,
      status: 1,
      confirmToken: this.otpConfirm
    }
    this.dialog.closeAll();
    this.activateAndDeActivateUser(obj);
  }

  onDeactivate(id: string, _status: number) {
    this.userId = id;

    if (_status == 0) {

      var obj1 = {
        userId: this.userLoginId
      }

      this.optionService.send2FAToken(obj1).subscribe();
      this.otpCounter = "";
      this.timer(1);
      this.otpConfirm = "";
      this.openDialogConfirmToken();
    }
    else {

      var obj = {
        userLoginId: this.userLoginId,
        userId: id,
        status: 0
      }

      this.activateAndDeActivateUser(obj);
    }
  }

  activateAndDeActivateUser(obj: any) {
    this.spinnerOverlay = true;

    this.optionService.ChangeUserStatus(obj).subscribe(data => {
      this.openSnackBar(this.translateService.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.getData();
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
      this.openSnackBar(error.error.message, 'snackBarError');
    })
  }


  openDialogConfirmToken(): void {
    const dialogRef = this.dialog.open(this.contentRef2, {
      width: '350px',
    });
  }


  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialogEdit(): void {
    const dialogRef = this.dialog.open(this.contentRef1, {
      width: '300px',
    });
  }

  onEdit(user: any) {
    this.editName = user['fullName'];
    this.editEmail = user['email'];
    this.editPhone = user['phoneNumber'];
    this.userId = user['id'];

    this.openDialogEdit();
  }

  updateUserInfo() {
    var obj = {
      userId: this.userId,
      fullName: this.editName,
      email: this.editEmail,
      phoneNumber: this.editPhone
    };

    console.log(obj)

    this.spinnerOverlay = true;
    this.service.UpdateAdminInfo(obj).subscribe(data => {
      this.openSnackBar(this.translateService.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.getData();
      this.dialog.closeAll();
      this.spinnerOverlay = false;
    }, error => {
      this.spinnerOverlay = true;
    })
  }

  onNoClick() {
    this.dialog.closeAll();
  }

  timer(minute: any) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    this.counterEnd = false;
    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.otpCounter = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        this.counterEnd = true;
        clearInterval(timer);
      }
    }, 1000);
  }

  resendOTP() {
    var obj1 = {
      userId: this.userLoginId
    }
    this.optionService.send2FAToken(obj1).subscribe();
    this.timer(1);

  }
}
